import React, { useContext, useState } from 'react';
import { NavbarPortal } from 'app/components';
import logo from 'app/images/Xplir_logo_RepPil_vektor_rgb.svg';
import { Link } from 'react-router-dom';
import { UserContext } from 'app/state/contexts/UserContext';
import MainMenu from './MainMenu';
import OrganizationMenu from './OrganizationMenu';
import { createPortal } from 'react-dom';
import Drawer from 'react-modern-drawer';
import { NotificationsDrawer } from './editor/navbar/NotificationsDrawer';
import { useEditorSelector } from 'app/state/contexts/EditorContext';
import { useComments } from 'app/api/useComments';
const NavbarDefault = () => {
  const { user } = useContext(UserContext);
  const { superId: sectionSuperId } = useEditorSelector((editor) => editor.section);
  const { commentNotifications } = useComments(sectionSuperId);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <NavbarPortal>
      <div className="d-flex justify-content-between">
        <div className="navbar--logo">
          <Link to="/">
            <img alt="logo" src={logo} />
          </Link>
        </div>
        <div className="d-flex">
          <OrganizationMenu />
          <MainMenu />
          <div className="d-flex align-items-center px-3 position-relative">
            <i
              className="fa-regular fa-bell"
              onClick={() => {
                setIsDrawerOpen(true);
              }}
            ></i>
            {commentNotifications?.length > 0 && <span className="notification-badge" />}
          </div>
        </div>
      </div>
      {createPortal(
        <Drawer open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} direction="right" size={450}>
          <NotificationsDrawer onClose={() => setIsDrawerOpen(false)} />
        </Drawer>,
        document.body,
        'notifications-drawer'
      )}
    </NavbarPortal>
  );
};

export default NavbarDefault;
